/**
 * Utility to check if the current time is within business hours.
 * 
 * Business Hours: Monday to Friday, 8:00 AM to 5:00 PM (17:00).
 */
export const isBusinessHoursActive = (): boolean => {
    const now = new Date();
    const day = now.getDay();
    const hours = now.getHours();
    const minutes = now.getMinutes();

    // Sunday: Closed
    if (day === 0) return false;

    // Saturday: 8:00 AM - 12:00 PM
    if (day === 6) {
        return hours >= 8 && hours < 12;
    }

    // Monday to Friday: 8:00 AM - 5:00 PM
    return hours >= 8 && hours < 17;
};
